import requestService from '@/services/request'
import { splitArrayIntoMap } from '@/util/mapArray'
import { createSlice } from '@reduxjs/toolkit'
import constants from '@/constants'
import { toastService } from '@/api/toast'
import { buildErrorToast } from '@/util/errorMessages'

const initialState = {
  withdrawValidation: { status: constants.IDLE, data: {}, error: null },
  transactions: { status: constants.IDLE, data: {} },
  pendingWithdrawals: { status: constants.IDLE, data: {}, pagination: {} },
  convertToStablecoin: { status: constants.IDLE, data: {}, error: null },
}

// Reducers / Slices

const wallet = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    getTransactionsStart: () => {},
    getTransactionsSuccess: () => {},
    getTransactionErrors: () => {},
    getPendingWithdrawalsStart: state => {
      state.pendingWithdrawals.status = constants.LOADING
    },
    getPendingWithdrawalsSuccess: (state, action) => {
      state.pendingWithdrawals.status = constants.COMPLETE
      state.pendingWithdrawals.data = {}
      state.pendingWithdrawals.data = splitArrayIntoMap(action.payload, 'currency')
    },
    getPendingWithdrawalsError: (state, action) => {
      state.pendingWithdrawals.status = constants.ERROR
      state.pendingWithdrawals.error = action.payload
    },
    getWithdrawValidationStart: state => {
      state.withdrawValidation.status = constants.LOADING
      state.withdrawValidation.data = constants.LOADING
      state.withdrawValidation.error = null
    },
    getWithdrawValidationError: (state, action) => {
      state.withdrawValidation.status = constants.ERROR
      state.withdrawValidation.error = action.payload
    },
    getWithdrawValidationSuccess: (state, action) => {
      state.withdrawValidation.status = constants.COMPLETE
      state.withdrawValidation.data = action.payload
    },
    resetWithdrawValidation: state => {
      state.withdrawValidation.status = constants.IDLE
      state.withdrawValidation.data = {}
      state.withdrawValidation.error = null
    },
    getConvertToStablecoinStart: state => {
      state.convertToStablecoin.status = constants.LOADING
    },
    getConvertToStablecoinSuccess: (state, action) => {
      state.convertToStablecoin.status = constants.COMPLETE
      state.convertToStablecoin.data = action.payload
    },
    getConvertToStablecoinError: (state, action) => {
      state.convertToStablecoin.status = constants.ERROR
      state.convertToStablecoin.error = action.payload
    },
    clearConvertToStablecoin: state => {
      state.convertToStablecoin.status = constants.IDLE
      state.convertToStablecoin.data = {}
      state.convertToStablecoin.error = null
    },
  },
})

export const { getConvertToStablecoinStart, getConvertToStablecoinSuccess, getConvertToStablecoinError, clearConvertToStablecoin } =
  wallet.actions
export const { getPendingWithdrawalsStart, getPendingWithdrawalsSuccess, getPendingWithdrawalsError } = wallet.actions
export const { getTransactionsStart, getTransactionsSuccess, getTransactionErrors } = wallet.actions
export const {
  getWithdrawValidationStart,
  getWithdrawValidationError,
  getWithdrawValidationSuccess,
  resetWithdrawValidation,
} = wallet.actions
export default wallet.reducer

export const selectWithdrawValidationStatus = () => state => state.wallet.withdrawValidation.status || constants.IDLE
export const selectWithdrawValidationData = () => state => state.wallet.withdrawValidation.data || {}
export const selectWithdrawValidationError = () => state => state.wallet.withdrawValidation.error || null

export const selectConvertToStablecoinStatus = () => state => state.wallet.convertToStablecoin.status || constants.IDLE
export const selectConvertToStablecoinData = () => state => state.wallet.convertToStablecoin.data || {}
export const selectConvertToStablecoinError = () => state => state.wallet.convertToStablecoin.error || null

// Thunks:

export const fetchPendingWithdrawals = () => async dispatch => {
  dispatch(getPendingWithdrawalsStart())
  try {
    var response = await requestService.get(`/withdrawals/get_pending/`)
  } catch (err) {
    dispatch(getPendingWithdrawalsError(err))
    return
  }
  dispatch(getPendingWithdrawalsSuccess(await response.json()))
}

export const validateWithdraw = code => async dispatch => {
  dispatch(getWithdrawValidationStart())
  let output
  try {
    const data = await requestService.post('/withdrawals/confirm/', { code })
    output = await data.json()
    dispatch(getWithdrawValidationSuccess(output))
  } catch (err) {
    dispatch(getWithdrawValidationError(err))
    toastService('fail', buildErrorToast(err, 'api_errors.titles.withdraw'))
    output = err
  }
  return output
}

export const convertToStablecoin = (fromCurrency, amount, targetCurrency, rateUpdateCode) => async dispatch => {
  dispatch(getConvertToStablecoinStart())
  try {
    var response = await requestService.post(`/currency_exchange/`, {
      source_currency: fromCurrency,
      source_amount: amount,
      target_currency: targetCurrency,
      rate_update_code: rateUpdateCode,
    })
  } catch (err) {
    dispatch(getConvertToStablecoinError(err))
    return
  }
  dispatch(getConvertToStablecoinSuccess(await response.json()))
}

// Selectors:
export const selectPendingWithdrawals = state => state.wallet.pendingWithdrawals.data
export const selectPendingWithdrawalsStatus = state => state.wallet.pendingWithdrawals.status
